"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var AppPaySystemsPayWaysListCtl = /** @class */ (function (_super) {
    __extends(AppPaySystemsPayWaysListCtl, _super);
    function AppPaySystemsPayWaysListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_payway_identity = UIUtils_1.UIUtils.IProp2Str(function (o) { o.payway_identity; });
        _this.dk_wallet_pool_tag = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wallet_pool_tag; });
        _this.dk_transaction_ttl_minutes = UIUtils_1.UIUtils.IProp2Str(function (o) { o.transaction_ttl_minutes; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_blockchain_apikey = UIUtils_1.UIUtils.IProp2Str(function (o) { o.blockchain_apikey; });
        _this.dk_wallet_crypto_currency_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wallet_crypto_currency_type_code; });
        _this.dk_wallet_crypto_currency_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wallet_crypto_currency_type_title; });
        _this.dk_wallet_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wallet_app_currency_id; });
        _this.dk_wallet_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.wallet_app_currency_title; });
        _this._errDialog = errDialog;
        return _this;
    }
    AppPaySystemsPayWaysListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    AppPaySystemsPayWaysListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    AppPaySystemsPayWaysListCtl.prototype.LoadData = function (key, onDone) {
        var _this = this;
        webAApi_1.ListInnerPayServicePayWaysByPayServiceIdGet.exec({ inner_pay_service_id: key }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    payway_identity: resp.list[i].payway_identity,
                    wallet_pool_tag: resp.list[i].wallet_pool_tag,
                    transaction_ttl_minutes: resp.list[i].transaction_ttl_minutes,
                    description: resp.list[i].description,
                    is_locked: resp.list[i].is_locked,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    wallet_app_currency_id: resp.list[i].wallet_app_currency_id,
                    wallet_app_currency_title: resp.list[i].wallet_app_currency_title,
                    wallet_crypto_currency_type_code: resp.list[i].wallet_crypto_currency_type_code,
                    wallet_crypto_currency_type_title: resp.list[i].wallet_crypto_currency_type_title,
                    blockchain_apikey: resp.list[i].blockchain_apikey
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AppPaySystemsPayWaysListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddInnerPayServicePayWay.exec({
            data: {
                payway_identity: data.payway_identity,
                inner_pay_service_id: data.inner_pay_service_id,
                wallet_crypto_currency_type_code: data.wallet_crypto_currency_type_code,
                is_locked: data.is_locked,
                description: data.description,
                wallet_pool_tag: data.wallet_pool_tag,
                transaction_ttl_minutes: data.transaction_ttl_minutes,
                wallet_app_currency_id: data.wallet_app_currency_id,
                blockchain_apikey: data.blockchain_apikey
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                payway_identity: data.payway_identity,
                date_changed: moment(resp.date_added_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                blockchain_apikey: data.blockchain_apikey,
                transaction_ttl_minutes: data.transaction_ttl_minutes,
                wallet_app_currency_id: data.wallet_app_currency_id,
                wallet_app_currency_title: resp.wallet_app_currency_title,
                is_locked: data.is_locked,
                description: data.description,
                wallet_crypto_currency_type_code: data.wallet_crypto_currency_type_code,
                wallet_crypto_currency_type_title: resp.wallet_crypto_currency_type_title,
                wallet_pool_tag: data.wallet_pool_tag
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    AppPaySystemsPayWaysListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditInnerPayServicePayWay.exec({
                data: {
                    payway_identity: data.payway_identity,
                    inner_pay_service_payway_id: data.key,
                    wallets_pool_tag: data.wallet_pool_tag,
                    transaction_ttl_minutes: data.transaction_ttl_minutes,
                    is_locked: data.is_locked,
                    description: data.description,
                    wallet_app_currency_id: data.wallet_app_currency_id,
                    blockchain_apikey: data.blockchain_apikey,
                    wallet_crypto_currency_type_code: data.wallet_crypto_currency_type_code
                }
            }, function (resp) {
                _tmp.payway_identity = data.payway_identity;
                _tmp.wallet_pool_tag = data.wallet_pool_tag;
                _tmp.transaction_ttl_minutes = data.transaction_ttl_minutes;
                _tmp.is_locked = data.is_locked;
                _tmp.description = data.description;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.wallet_app_currency_id = data.wallet_app_currency_id;
                _tmp.wallet_app_currency_title = resp.wallet_app_currency_title;
                _tmp.blockchain_apikey = data.blockchain_apikey;
                _tmp.wallet_crypto_currency_type_code = data.wallet_crypto_currency_type_code;
                _tmp.wallet_crypto_currency_type_title = resp.wallet_crypto_currency_type_title;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AppPaySystemsPayWaysListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    AppPaySystemsPayWaysListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteInnerPayServicePayWay.exec({ data: { inner_pay_service_payway_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    AppPaySystemsPayWaysListCtl.prototype.SetIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetInnerPayServicePayWayIsLocked.exec({ data: { inner_pay_service_payway_id: key, is_locked: IsLocked } }, function (resp) {
                _tmp.is_locked = IsLocked;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return AppPaySystemsPayWaysListCtl;
}(BaseController_1.BaseController));
exports.AppPaySystemsPayWaysListCtl = AppPaySystemsPayWaysListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_paysystem/ctl/AppPaySystemsPayWaysListCtl.ts
// module id = 1056
// module chunks = 0